export default __webpack_public_path__ + "static/franchise-6-bc00bf50256d1236942142b246fc64f6.jpg";